import Vue from 'vue'
import Vuex from 'vuex'
import state from './state.js'
import mutations from './mutations.js'
import getters from './getters.js'
import actions from './actions.js'
import conversation from './modules/conversation'
import group from './modules/group'
import user from './modules/user'
import video from './modules/video'
import friend from './modules/friend'
import blacklist from './modules/blacklist'
import groupLive from './modules/groupLive'
Vue.use(Vuex);
let modules = {
    conversation,
    group,
    friend,
    blacklist,
    user,
    video,
    groupLive,
  }
export default new Vuex.Store({state, mutations, getters, actions, modules})



// WEBPACK FOOTER //
// ./src/vuex/store.js